/**
 * Returns the URL to the API.
 */
export function resolveApiUrl() {
  return `https://${process.env.DOMAIN ?? ''}/`;
}

/**
 * Returns URL to the public web address.
 */
export function resolvePublicUrl() {
  return `https://${process.env.PUBLIC ?? ''}/`;
}

/**
 *  Returns the xsite integration domain.
 *
 *  TODO: Handle in a more dynamic way.
 */
export const resolveXSiteIntegrationDomain = () => {
  return `https://${process.env.XSITE_INTEGRATION_DOMAIN ?? ''}/`;
};

/**
 *  Returns the Leica integration domain.
 *
 *  TODO: Handle in a more dynamic way.
 */
export const resolveLeicaIntegrationDomain = () => {
  return `https://${process.env.LEICA_INTEGRATION_DOMAIN ?? ''}/`;
};

/**
 *  Returns the Cerbos cluster url.
 */
export const resolveCerbosUrl = () => {
  // Env-variables existence verified using DotEnv-example file.
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return `https://${process.env.CERBOS_URL}`;
};
